import React, {FC, useEffect, useState} from 'react'
import moment from 'moment-timezone'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {MessageType} from '../Types'
import NodataYet from '../../../../Components/NodataYet'
import {MessageDeliveryStatus, visualizeHiddenCharacters} from '../Common'
import {useGetSchedulerLogQuery} from '../../../../../services/cellcast'
import {Link, useParams} from 'react-router-dom'
import clsx from 'clsx'

const FileSchedulerMessageLog = () => {
  const {id} = useParams()

  const {data, isLoading, isFetching, refetch} = useGetSchedulerLogQuery({id})
  return (
    <div className=''>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Scheduler Messages Log</span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='d-flex justify-content-end'></div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data && data?.data?.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='p-0'>Execution Date</th>
                        <th className='p-0 min-w-60px ps-3'>Note</th>
                        <th className='p-0 max-w-200px ps-3'>Message</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.map((key, i) => {
                            return (
                              <React.Fragment key={i}>
                                <tr className='border-dashed border-2 border-bottom'>
                                  <td className='top-align'>
                                    <span className='text-dark-400 p-0'>
                                      {moment(key?.executionDate).format('DD-MM-YYYY HH:mm:ss')}
                                    </span>
                                  </td>
                                  <td className='top-align'>
                                    <div className='pull-left'>
                                      {key?.note.map((it) => (
                                        <p>
                                          Step: {it?.step} - {it?.text}
                                        </p>
                                      ))}
                                    </div>
                                  </td>
                                  <td className='top-align'>
                                    <div className='message-display'>
                                      {visualizeHiddenCharacters(key?.schedule?.message || '-')}
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            )
                          })}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <NodataYet message='No recent file scheduler sms messages (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default FileSchedulerMessageLog
